import SpinnerIcon from 'assets/spinner.svg?react'
import { motion } from 'framer-motion'
import React from 'react'
import styled from 'styled-components'

const LoadingBlurContainer = styled.div`
  display: flex;
  position: absolute;
  backdrop-filter: blur(2px);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

const LoadingIcon = styled(motion.div)`
  margin: auto;
`

export const LoadingBlur: React.FC = () => {
  return (
    <LoadingBlurContainer>
      <LoadingIcon
        animate={{ rotate: 360 }}
        transition={{ duration: 0.5, repeat: Infinity, ease: 'linear' }}>
        <SpinnerIcon width='30px' height='30px' />
      </LoadingIcon>
    </LoadingBlurContainer>
  )
}
